/// <amd-module name="Artifacts/Nuget/services/NuGetRestApiUrlGeneratorService" />
import { generatePackagingServiceRestApiUri, IRestApiRoutes } from "Artifacts/Root/Utils/RestApi";
import { IVssService, Services, VssService } from "VSS/Platform/Context";
import { replaceRouteValues, Uri } from "VSS/Platform/Util/Url";

const NuGetArea = "nuget";

// Used in Download
const PackageVersionContent: IRestApiRoutes = {
  locationId: "6EA81B8C-7386-490B-A71F-6CF23C80B388",
  resource: "content",
  routeTemplate:
    "packaging/feeds/{feedId}/{area}/packages/{packageName}/versions/{packageVersion}/{resource}",
};

// Used in CtF, to download nuget + credential provider
const ClientDownload: IRestApiRoutes = {
  locationId: "9E467250-2C61-4278-920B-0C3C618F779F",
  resource: "client",
  routeTemplate: "public/{area}/{resource}/{fileName}", // todo: doesn't seem to be rest, verify
};

// Used for embedded license
const FlatGetFile: IRestApiRoutes = {
  locationId: "76871FBD-8952-415B-9931-A80BC784EBCF",
  resource: "flat2",
  routeTemplate: "_packaging/{feedId}/{area}/v3/{resource}/{id}/{version}/{file}",
};

export interface INuGetRestApiUrlGeneratorService extends IVssService {
  getDownloadPackageVersionContentUrl(
    feedId: string,
    packageName: string,
    packageVersion: string,
    includeProject: boolean,
    publicAccessMapping: string,
  ): string;
  getDownloadClientUrl(
    fileName: string,
    includeProject: boolean,
    publicAccessMapping: string,
  ): string;
  getExtractFromNupkgUrl(
    feedId: string,
    packageName: string,
    packageVersion: string,
    innerFilePath: string,
    includeProject: boolean,
    publicAccessMapping: string,
  ): string;
}

class NuGetRestApiUrlGeneratorService extends VssService
  implements INuGetRestApiUrlGeneratorService {
  public getDownloadPackageVersionContentUrl(
    feedId: string,
    packageName: string,
    packageVersion: string,
    includeProject: false,
    publicAccessMapping: string,
  ): string {
    const path = replaceRouteValues(PackageVersionContent.routeTemplate, {
      feedId,
      area: NuGetArea,
      packageName,
      packageVersion,
      resource: PackageVersionContent.resource,
    });

    return generatePackagingServiceRestApiUri(
      this.pageContext,
      path,
      publicAccessMapping,
      false,
      includeProject,
    );
  }

  public getDownloadClientUrl(
    fileName: string,
    includeProject: boolean,
    publicAccessMapping: string,
  ): string {
    const path = replaceRouteValues(ClientDownload.routeTemplate, {
      area: NuGetArea,
      resource: ClientDownload.resource,
      fileName,
    });

    return generatePackagingServiceRestApiUri(
      this.pageContext,
      path,
      publicAccessMapping,
      false,
      includeProject,
    );
  }

  public getExtractFromNupkgUrl(
    feedId: string,
    packageName: string,
    packageVersion: string,
    innerFilePath: string,
    includeProject: boolean,
    publicAccessMapping: string,
  ): string {
    const path = replaceRouteValues(FlatGetFile.routeTemplate, {
      feedId,
      area: NuGetArea,
      resource: FlatGetFile.resource,
      id: packageName,
      version: packageVersion,
      file: `${packageName}.${packageVersion}.nupkg`,
    });

    const uri = new Uri(
      generatePackagingServiceRestApiUri(
        this.pageContext,
        path,
        publicAccessMapping,
        true /* ignoreApisRelativePath */,
        includeProject,
      ),
    );

    uri.addQueryParams({
      extract: innerFilePath,
    });

    return uri.absoluteUri;
  }
}

Services.add("INuGetRestApiUrlGeneratorService", {
  serviceFactory: NuGetRestApiUrlGeneratorService,
});
